<div class="confirm-header">
  <h3>{{ title }}</h3>
  <i *ngIf="showCloseIcon"
     (click)="action(false)"
     (keydown.enter)="action(false)"
     tabindex="0"
     role="button"
     class="close-icon icon-cross_16px"></i>
</div>
<div *ngIf="!!description" class="content-modal" [innerHTML]="description"></div>
<div class="controls">
  <button id="dismiss"
          appTrackClickButton
          type="button"
          class="button secondary"
          *ngIf="showButtonNo"
          (click)="action(false)">{{ buttonsTitle.dismiss }}</button>
  <button id="confirm"
          appTrackClickButton
          type="button"
          class="button primary"
          *ngIf="showButtonYes"
          (click)="action(true)">{{ buttonsTitle.confirm }}</button>
</div>
